import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-page-spinner',
    templateUrl: './page-spinner.component.html',
    styleUrls: ['./page-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PageSpinnerComponent {

    @Input()
    public marginTop: number = 24

}
